import getLocalString from "constants/Localization";
import {
  CustomCreateCustomEventMutationVariables,
  useCustomCreateCustomEventMutation,
} from "generated/graphql";
import useBitumioMutation from "hooks/useBitumioMutation";

export const useCreateCustomEvent = () => {
  const [mutation, { loading, data, error }] = useCustomCreateCustomEventMutation();
  const [createCustomEvent, context] = useBitumioMutation(
    {
      mutation,
      loading,
      data,
      error,
      key: "createCustomEvent",
    },
    {
      successMessage: getLocalString("customEvents.create-custom-event-success"),
      failureMessage: getLocalString("customEvents.create-custom-event-failure"),
    }
  );
  return [createCustomEvent, context] as const;
};
